import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import PlanningStatusEnum from '../../../Enums/PlanningStatusEnum';
import statusHelper from '../../../Helpers/statusHelper';
import PlanningItemStatusUpdateItem from '../../../Domain/PlanningItemStatusUpdateItem';
import PlanningCancellationDecisionEnum from '../../../Enums/PlanningCancellationDecisionEnum';
import PlanningCancellationDecisionOptionsArray from '../../../Enums/PlanningCancellationDecisionOptionsArray';

export default class PlanningItemStatusUpdateWindowDescription {
  static titleForCreate = 'PlanningItem Mass Status Update';
  static titleForEdit = 'PlanningItem Mass Status Update';
  static itemType = PlanningItemStatusUpdateItem;
  static messageOnSuccess = 'The status of the selected Planning Items has been updated.';

  static approveBeforeSaveCheck = (item) =>
    item.To === PlanningStatusEnum.Closed || item.To === PlanningStatusEnum.Cancelled;
  static approveBeforeSaveMessage = "You won't be able to go back. Are you sure?";

  static serviceFunction = async (item) =>
    PlanningDetailsItemService.UpdateMultiplePlanningDetailItemStatusByPricingIds(
      item.PricingIds,
      item.Periods.map((period) => period.apply),
      item.To,
      item.CancellationDecision,
      item.CancellationComment
    );

  static pagesInGeneralEditWizzard = [
    {
      fields: [
        {
          fieldName: 'CountryInfo',
          label: '',
          className: 'col-4',
          type: InputTypesEnum.InfoCallout,
          buildContent: (item) => {
            const countryNames = item.CountryNames ?? [];
            return {
              paragraphs: ['It will be applied on the following country(ies):'],
              chips: countryNames,
              chipsLabel: countryNames.length === 1 ? 'country' : 'countries',
            };
          },
        },
        {
          fieldName: 'Periods',
          label: 'Fieldwork Periods',
          className: 'col-8',
          type: InputTypesEnum.FieldworkPeriodApplyTable,
        },
        {
          fieldName: 'StatusInfo',
          label: '',
          className: 'col-4',
          type: InputTypesEnum.InfoCallout,
          buildContent: (item) => ({
            paragraphs: statusHelper.getFromInfoParagraphs(item.To),
          }),
        },
        {
          fieldName: 'To',
          label: 'To',
          className: 'col-8',
          type: InputTypesEnum.Select,
          selectvalues: statusHelper.getToSelectValues(),
          validityChecker: (value) => (value ? '' : 'Please select a status.'),
        },
        {
          fieldName: 'CancellationDecision',
          label: 'Cancellation Decision',
          className: 'col-12',
          type: InputTypesEnum.PillSelect,
          selectvalues: PlanningCancellationDecisionOptionsArray,
          hide: (item) => item.To !== PlanningStatusEnum.Cancelled,
          validityChecker: (value) => (value ? '' : 'Please select a cancellation decision.'),
        },
        {
          fieldName: 'CancellationComment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          numberOfRows: 3,
          hide: (item) =>
            item.To !== PlanningStatusEnum.Cancelled ||
            item.CancellationDecision !== PlanningCancellationDecisionEnum.Other,
          validityChecker: (value) => (value && value.trim() ? '' : 'Please enter a comment.'),
        },
      ],
    },
  ];
}
